import { Utilities } from '@tess-core/shared';

export const getProperty = <T, K extends keyof T>(obj: T, key: K): T[K] => {
  return obj[key];
};

export const getPropertyValue = (
  propertyType: string,
  propertyValue: number | string | undefined,
): number | string | undefined => {
  switch (propertyType) {
    case 'number':
      return Utilities.numberOrNull(propertyValue);
    case 'string':
      return propertyValue ?? undefined;
    default:
      return undefined;
  }
};
